// French for the standing brief. Keys already carried by i18n/common.fr.ts are not repeated;
// the state words and `ball` are registered with the same French as PeoplePage on purpose.
import { registerFr } from '../i18n/index.js';

registerFr({
  // ── addressing ──
  'no person was addressed': 'aucune personne n’a été adressée',
  'This address names no person': 'Cette adresse ne nomme aucune personne',
  'A person brief is opened as #person?id=N from a row on the People board.':
    'Une fiche de personne s’ouvre en #person?id=N depuis une ligne du tableau des personnes.',
  'reading the record…': 'lecture du dossier…',
  'the record did not answer': 'le dossier n’a pas répondu',
  'Could not read this person': 'Impossible de lire cette personne',

  // ── the masthead ──
  'role not named': 'fonction non nommée',
  'no current affiliation on the record': 'aucun rattachement courant au dossier',
  'register not set': 'registre non défini',
  // the mast's buying-influence tag beside the tier (R7 §6.1) — ProfileZone's word, identical
  'estimated': 'estimé',
  'tier': 'niveau',
  'cadence': 'cadence',
  '{n} unconfirmed': '{n} non confirmés',
  'do not contact': 'ne pas contacter',
  'Add fact': 'Ajouter un fait',
  // 'Research' seul est le NOM de la quatrième colonne ci-dessous ; le verbe de l'en-tête a sa
  // propre clé de contexte, ainsi les deux ne s'écrasent jamais.
  'Research‖verb': 'Rechercher',
  'Queuing…': 'Mise en file…',
  'Send an agent to read the web for this person: the employer and the role from the organisation’s own pages and the press, never LinkedIn. Everything arrives in Review as a proposal.':
    'Envoyer un agent lire le web sur cette personne : l’employeur et la fonction depuis les pages de l’organisation et la presse, jamais LinkedIn. Tout arrive en Revue comme proposition.',
  'Research {ref} queued. What it can cite arrives in Review as a proposal; nothing is written until you hold it.':
    'Recherche {ref} mise en file. Ce qu’elle peut citer arrive en Revue comme proposition ; rien n’est écrit tant que vous ne l’avez pas retenu.',

  // ── the rail ──
  'Day': 'Jour',
  'since last touch': 'depuis le dernier contact',
  'Ball': 'Balle',
  'was due': 'était dû le',
  'Threads': 'Fils',
  'mails': 'mails',
  '{n} mail': '{n} mail', '{n} mails': '{n} mails',
  'the mail service did not answer': 'le service mail n’a pas répondu',
  'counting the correspondence…': 'décompte de la correspondance…',
  'no mail with this person on record': 'aucun mail avec cette personne au dossier',
  '{n} from them': '{n} de sa part', '{n} from you': '{n} de votre part',
  'their median reply {h} h': 'sa réponse médiane {h} h',
  'Sources': 'Sources',
  '{n} fact with evidence': '{n} fait avec preuve',
  '{n} facts with evidence': '{n} faits avec preuve',
  '{n} interaction': '{n} échange', '{n} interactions': '{n} échanges',
  '{n} fact': '{n} fait', '{n} facts': '{n} faits',
  '{n} affiliation': '{n} affiliation', '{n} affiliations': '{n} affiliations',
  'nobody has held them': 'personne ne les a retenus',
  'every claim on this page is held': 'toute affirmation de cette page est retenue',
  'nothing has been logged against them': 'rien n’a été consigné à son sujet',
  '{us} with us · {them} with them': '{us} chez nous · {them} chez eux',
  'no open commitment either way': 'aucun engagement ouvert dans un sens ou dans l’autre',

  // ── next move ──
  'Next move': 'Prochain geste',
  'ranked · the page arranges, it does not decide':
    'classé · la page dispose, elle ne décide pas',
  'ball': 'balle',
  'Nothing is owed either way. A move appears here when a commitment is logged against this person — from a meeting, a mail or by hand — so the next thing to do is always something somebody actually said.':
    'Rien n’est dû dans un sens ni dans l’autre. Un geste apparaît ici dès qu’un engagement est consigné pour cette personne — depuis une réunion, un courriel ou à la main — pour que la prochaine chose à faire soit toujours quelque chose que quelqu’un a réellement dit.',


  // ── the writing profile ──
  'How you two write': 'Comment vous vous écrivez',
  'the writing profile drives every draft to them': 'le profil d’écriture pilote chaque brouillon vers elle',

  // ── the timeline ──
  'Latest': 'Derniers échanges',
  'newest {n} of {total}': 'les {n} plus récents sur {total}',
  'No interaction names this person. A meeting, a mail or a note becomes an interaction with them as a participant; the seed import files the two research meetings that way.':
    'Aucun échange ne nomme cette personne. Une réunion, un courriel ou une note devient un échange où elle figure comme participante ; l’import initial classe ainsi les deux réunions de recherche.',

  // ── the record ──
  'What we currently know': 'Ce que nous savons à ce jour',
  'Show everything': 'Tout afficher',
  'Only unconfirmed ({n})': 'Seulement les non confirmés ({n})',
  'nothing unconfirmed here': 'rien de non confirmé ici',
  'unconfirmed': 'non confirmé',
  'no value': 'aucune valeur',
  '{key} is held.': '{key} est retenu.',
  '{org} is held.': '{org} est retenue.',
  'since': 'depuis',

  // ── the four columns ──
  'Identity': 'Identité',
  'Affiliations': 'Rattachements',
  'Relationship': 'Relation',
  'Research': 'Recherche',
  'former': 'ancien',
  'retracted': 'retiré',

  // ── the vocabularies a row prints ──
  'mail_in': 'courriel reçu',
  'mail_out': 'courriel envoyé',
  // 'meeting', 'interaction' et 'Evidence' sont les mots de ReviewPage (rencontre, point de
  // contact, Preuves) — enregistrés là-bas, pas répétés ici.
  'call': 'appel',
  'note': 'note',
  'post': 'publication',
  'signal': 'signal',
  'operator': 'opérateur',
  'agent': 'agent',
  'import': 'import',
  'official': 'officiel',
  'professional': 'professionnel',
  'meeting_label': 'étiquette de réunion',
  'mail_signature': 'signature de courriel',
  'snapshot': 'capture',
  'surfe': 'Surfe',
  'manual': 'manuel',
  'url': 'URL',
  'document': 'document',

  // ── the states, shared with the board ──
  'cooling': 'refroidit',
  'warm': 'chaud',
  'quiet': 'silencieux',

  // ── the two dialogues ──
  'Write it': 'Écrire',
  'Key': 'Clé',
  'Value': 'Valeur',
  'Evidence reference': 'Référence de la preuve',
  'a URL, a snapshot id, an interaction ref': 'une URL, un identifiant de capture, une référence d’échange',
  'A fact needs a key, for example identity.email.':
    'Un fait a besoin d’une clé, par exemple identity.email.',
  '{key} written. Whatever the key said before is superseded, not erased.':
    '{key} écrit. Ce que la clé disait avant est remplacé, non effacé.',
  'Writing a key that already has a value supersedes the old one. Nothing is overwritten and nothing is lost.':
    'Réécrire une clé qui a déjà une valeur remplace l’ancienne. Rien n’est écrasé et rien n’est perdu.',
  'Archive {name}?': 'Archiver {name} ?',
  'They leave the register and the board. Every fact, affiliation, interaction and commitment stays exactly where it is, and the archive can be searched with status=archived.':
    'La personne quitte le registre et le tableau. Chaque fait, rattachement, échange et engagement reste exactement où il est, et l’archive se consulte avec status=archived.',
  '{name} is archived. The record keeps everything.':
    '{name} est archivée. Le dossier garde tout.',

  // ── round 3b : d’où vient cette personne ──
  'Origin': 'Origine',
  'the first thing the record knows about this person':
    'la première chose que le dossier sait de cette personne',
  'email': 'e-mail',
  'phone': 'téléphone',
  'location': 'lieu',
  'Nothing has passed between you and this person yet. The next move, the reason to act and the writing profile appear here once something does.': 'Rien ne s’est encore passé entre vous et cette personne. Le prochain geste, la raison d’agir et le profil d’écriture apparaissent ici dès que quelque chose arrive.',
}, 'PersonPage');
